import SignalField from "@/components/SignalField";

const rows = [
  ["Real estate", "Live today"],
  ["Insurance", "Next vertical"],
  ["Lending and wealth", "Next vertical"],
  ["Elective healthcare", "Expansion"],
];

export default function Focus() {
  return (
    <section className="focus" id="focus" data-testid="focus-section">
      <SignalField variant="local" rgb="164,156,255" opacity={0.85} testId="signal-field-focus" />
      <div className="wrap">
        <div className="label mono">Where we focus</div>
        <h2 className="section-title">
          Built for sales where context, consistency and timing decide the outcome
        </h2>
        <p className="section-copy">
          Real estate is ThinkWire’s proving ground. The same workflow extends to other complex sales
          industries as the product gains vertical knowledge and compliance depth.
        </p>
        <div className="focus-grid">
          <div className="focus-main">Live today in real estate. Designed for sales teams.</div>
          <div className="focus-side">
            {rows.map(([k, v]) => (
              <div className="focus-row" key={k}>
                <strong>{k}</strong>
                <span>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
